export function Pager({
  offset,
  limit,
  total,
  onChange,
}: {
  offset: number
  limit: number
  total: number
  onChange: (offset: number) => void
}) {
  if (total === 0) return null
  const first = offset + 1
  const last = Math.min(offset + limit, total)
  return (
    <div className="pager">
      <span>
        {first}–{last} of {total.toLocaleString()}
      </span>
      <div className="row" style={{ gap: 6 }}>
        <button
          className="btn sm"
          disabled={offset === 0}
          onClick={() => onChange(Math.max(0, offset - limit))}
        >
          ← Previous
        </button>
        <button
          className="btn sm"
          disabled={last >= total}
          onClick={() => onChange(offset + limit)}
        >
          Next →
        </button>
      </div>
    </div>
  )
}
